import React, { FC } from "react";
import { UIBrandedFareInfo, UIFlightData } from "@flights/types";
import Frame from "../../../../Frame";
import { useFlightCardLuggageController } from "./useFlightCardLuggage.controller";
import { Stack, Text, TextProps } from "@bookingcom/bui-react";
import { CardAncillariesPopover, CardAncillariesPopoverProps } from "@flights/search-ui";
import { AlignerProps } from "@bookingcom/bui-react/components/Button/Button.types";
import { useSplitBoundsCondition } from "../../../../../../utils/experiments/funnel/flights_split_bounds_us";
import { formatFareName } from "@flights/branded-fares";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import flights_web_sr_baggage_transparency from "../../../../../../utils/experiments/funnel/flights_web_sr_baggage_transparency";
import flights_web_flight_card_update_desktop from "../../../../../../utils/experiments/funnel/flights_web_flight_card_update_desktop";

export const FlightCardLuggageDesktop: FC<{
  flight: UIFlightData;
  brandedFareInfo?: UIBrandedFareInfo;
  brandedFareInfoAlignment?: TextProps["align"];
  buttonAlignment?: AlignerProps["alignment"];
  iconsAlignment?: CardAncillariesPopoverProps["align"];
}> = ({ flight, brandedFareInfo, buttonAlignment, brandedFareInfoAlignment = "end", iconsAlignment = "end" }) => {
  const i18n = useI18n();
  const { isSplitBounds } = useSplitBoundsCondition();
  const { luggageList } = useFlightCardLuggageController(flight);

  if (luggageList.length === 0) {
    return null;
  }

  return (
    <Stack gap={0.5}>
      {brandedFareInfo ? (
        <BrandedFareDescription brandedFareInfo={brandedFareInfo} align={brandedFareInfoAlignment} />
      ) : null}

      <CardAncillariesPopover
        titleText={
          isSplitBounds || flights_web_sr_baggage_transparency.getExp(false).trackWithDefaultStage()
            ? undefined
            : i18n.trans(t("flights_sr_hover_included_baggage"))
        }
        ancillaries={luggageList}
        align={iconsAlignment}
        buttonAlignment={buttonAlignment}
        onPopoverOpen={() => {
          flights_web_sr_baggage_transparency.getExp(false).goals.desktop_sr_card_baggage_hover();
          !isSplitBounds && flights_web_flight_card_update_desktop.goals.open_baggage_info();
        }}
      />
    </Stack>
  );
};

const BrandedFareDescription: FC<{ brandedFareInfo: UIBrandedFareInfo; align: TextProps["align"] }> = ({
  brandedFareInfo,
  align
}) => {
  const { fareName } = brandedFareInfo;

  return (
    <Frame>
      <Text variant="small_1" align={align} color="neutral">
        {formatFareName(fareName)}
      </Text>
    </Frame>
  );
};
